import { ReactElement } from 'react';
import { InputProps, Input as AntInput } from 'antd';
import { DataTestIdProxy } from 'common/components/Utilities/DataTestIdProxy';

export const InputPassword = ({ dataTestId, ...restProps }: InputProps & { dataTestId?: string }): ReactElement => (
  <DataTestIdProxy dataTestId={dataTestId}>
    <AntInput.Password {...restProps} />
  </DataTestIdProxy>
);
